import { useQuery } from '@tanstack/react-query'
import { api } from '@/lib/api'
import type { Configuracion } from '@/types/database'

export function useConfiguracion() {
  return useQuery({
    queryKey: ['configuracion'],
    queryFn: () => api.get<Configuracion>('/api/configuracion'),
    staleTime: 5 * 60 * 1000,
    retry: false,
  })
}
